import { filter, find, isNil, some } from "lodash";
import { PaymentStatus } from "../../PaymentContainerClient/commons/enums";
import InstallmentDto from "../../PaymentContainerClient/dtos/InstallmentDto";
import PaymentDto from "../../PaymentContainerClient/dtos/PaymentDto";

// TODO we can call this kind of functions something like:
// getAll/getFirst..NotStartedPaymentInstall...
export default function getAllNotPaidNotScheduledNotOnHoldInstallments(
    installments: InstallmentDto[],
    payments: PaymentDto[]
): InstallmentDto[] {
    return filter(installments, (installment) => {
        return isNil(
            find(
                payments,
                (payment) =>
                    some(
                        payment.installmentIds,
                        (installmentId) => installmentId === installment.id
                    ) &&
                    (payment.status === PaymentStatus.Paid ||
                        payment.status === PaymentStatus.Scheduled ||
                        payment.status === PaymentStatus.OnHold)
            )
        );
    });
}
